import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import {
    contentApi, documentApi, previewAdminApi, previewApi, searchAdminApi,
    documentsAdminApi, chaptersAdminApi, sectionsAdminApi, variantsAdminApi,
    tagsAdminApi, vendorsAdminApi, usersAdminApi, publishAdminApi, unpublishedAdminApi,
    appSettingsAdminApi, documentSettingsAdminApi, workspacesAdminApi, systemSettingsAdminApi,
    logsAdminApi, brandApi, regionApi, areasApi, countryApi, propertyApi,
    variantApi, variantHistoryApi, downloadDocumentApi, authApi, appSettingsApi,
    documentSettingsApi, workspacesApi, brandsAdminApi, areasAdminApi,
} from '@SERVICES';
import { documentGenerationStepsSlice } from '@REDUCERS';

import stepsRepository from '@REPOSITORIES/local-repository/steps-repository';

export default function invalidateData(dispatch: ThunkDispatch<any, any, AnyAction>) {
    dispatch(
        documentApi.util.resetApiState(),
    );
    dispatch(
        contentApi.util.resetApiState(),
    );
    dispatch(
        previewApi.util.resetApiState(),
    );
    dispatch(
        previewAdminApi.util.resetApiState(),
    );
    dispatch(
        searchAdminApi.util.resetApiState(),
    );

    dispatch(documentGenerationStepsSlice.actions.reset());

    stepsRepository.clear();
}

export function invalidateDataExcept(
    dispatch: ThunkDispatch<any, any, AnyAction>,
    excludeApis: string[] = []
) {
    // Helper to check if an API should be excluded
    const shouldReset = (apiName: string) => !excludeApis.includes(apiName);

    if (shouldReset('documentApi')) {
        dispatch(documentApi.util.resetApiState());
    }
    if (shouldReset('contentApi')) {
        dispatch(contentApi.util.resetApiState());
    }
    if (shouldReset('previewApi')) {
        dispatch(previewApi.util.resetApiState());
    }
    if (shouldReset('previewAdminApi')) {
        dispatch(previewAdminApi.util.resetApiState());
    }
    if (shouldReset('searchAdminApi')) {
        dispatch(searchAdminApi.util.resetApiState());
    }

    dispatch(documentGenerationStepsSlice.actions.reset());
    stepsRepository.clear();
}

export function invalidateWorkspaceData(dispatch: ThunkDispatch<any, any, AnyAction>) {
    // Reset all workspace-dependent API states
    
    // User-facing APIs
    dispatch(documentApi.util.resetApiState());
    dispatch(contentApi.util.resetApiState());
    dispatch(previewApi.util.resetApiState());
    dispatch(brandApi.util.resetApiState());
    dispatch(regionApi.util.resetApiState());
    dispatch(areasApi.util.resetApiState());
    dispatch(countryApi.util.resetApiState());
    dispatch(propertyApi.util.resetApiState());
    dispatch(variantApi.util.resetApiState());
    dispatch(variantHistoryApi.util.resetApiState());
    dispatch(downloadDocumentApi.util.resetApiState());
    dispatch(appSettingsApi.util.resetApiState());
    dispatch(documentSettingsApi.util.resetApiState());
    dispatch(workspacesApi.util.resetApiState());

    // Admin APIs
    dispatch(documentsAdminApi.util.resetApiState());
    dispatch(chaptersAdminApi.util.resetApiState());
    dispatch(sectionsAdminApi.util.resetApiState());
    dispatch(variantsAdminApi.util.resetApiState());
    dispatch(tagsAdminApi.util.resetApiState());
    dispatch(vendorsAdminApi.util.resetApiState());
    dispatch(usersAdminApi.util.resetApiState());
    dispatch(publishAdminApi.util.resetApiState());
    dispatch(unpublishedAdminApi.util.resetApiState());
    dispatch(previewAdminApi.util.resetApiState());
    dispatch(searchAdminApi.util.resetApiState());
    dispatch(appSettingsAdminApi.util.resetApiState());
    dispatch(documentSettingsAdminApi.util.resetApiState());
    dispatch(workspacesAdminApi.util.resetApiState());
    dispatch(systemSettingsAdminApi.util.resetApiState());
    dispatch(logsAdminApi.util.resetApiState());
    dispatch(brandsAdminApi.util.resetApiState());
    dispatch(areasAdminApi.util.resetApiState());

    // Reset document generation steps
    dispatch(documentGenerationStepsSlice.actions.reset());

    // Clear local storage
    stepsRepository.clear();
}
